import { type PseudoStateDataMap, type RuntimePseudoState } from '../../types';

export const checkableSelector = 'input, option';
export const pseudoStatesPriority: RuntimePseudoState[] = ['active', 'checked', 'focus', 'hover'];

export const hasStateData = <TStateData>(
  stateDataMap: PseudoStateDataMap<TStateData>,
  state: RuntimePseudoState,
): boolean => {
  if ('default' === state) {
    return true;
  }

  return null != stateDataMap[`${state}StateData`];
};

export const getStateData = <TStateData>(
  stateDataMap: PseudoStateDataMap<TStateData>,
  state: RuntimePseudoState,
): TStateData | null => {
  if ('default' === state) {
    return stateDataMap.defaultStateData;
  }

  return stateDataMap[`${state}StateData`] ?? null;
};

export const checkPseudoState = (hoverElement: HTMLElement, state: RuntimePseudoState): boolean => {
  switch (state) {
    case 'active':
      return hoverElement.matches(':active') || null !== hoverElement.querySelector(':active');
    case 'checked':
      return hoverElement.matches(':checked') || null !== hoverElement.querySelector(`${checkableSelector}:checked`);
    case 'focus':
      return hoverElement.matches(':focus, :focus-within');
    case 'hover':
      return hoverElement.matches(':hover');
    default:
      return false;
  }
};
